import { render, staticRenderFns } from "./FormIRTC.vue?vue&type=template&id=6e9bf8ce&scoped=true&"
import script from "./FormIRTC.vue?vue&type=script&lang=js&"
export * from "./FormIRTC.vue?vue&type=script&lang=js&"
import style0 from "./FormIRTC.vue?vue&type=style&index=0&id=6e9bf8ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9bf8ce",
  null
  
)

export default component.exports